import { useEffect, useRef } from 'react';
import styles from './style.module.css'

export default function ErrorModal({title,subTitle,onClose}){
    const mainRef=useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
          if (mainRef.current && !mainRef.current.contains(event.target)) {
            onClose();
          }
        }
        if (mainRef.current) {
          document.addEventListener("mousedown", handleClickOutside);
          document.addEventListener("keydown", handleInputKeyDown);
        }
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
          document.removeEventListener("keydown", handleInputKeyDown);
        };
    }, []);

    const handleInputKeyDown=(e)=>{
        if(e.key ==='Enter' || e.key==='Escape'){
            onClose();
        }
    }

    return(
        <div className={styles['wrap']}>
            <div className={styles['main']} ref={mainRef}>
                <div className={styles['icon']}>
                    <span className={styles['icon-background']}></span>
                    <span className={styles['icon-svg']}></span>
                </div>
                <div className={styles['body']}>
                    <span className={styles['body-title']}>{title}</span>
                    <span className={styles['body-text']}>{subTitle}</span>
                </div>
                <div className={styles['close-btn']} onClick={onClose}>
                    <div className={styles['close-svg']}></div>
                </div>
            </div>
        </div>
    )
}

